import React from "react";
import PropTypes from "prop-types";
import { VictoryLabel } from "victory";
import { useMediaQuery } from "@material-ui/core";
import { getIconColor } from "./styles";

const IconLabel = ({ index, icons, ...rest }) => {
  const isXL = useMediaQuery("(min-width:1900px)");
  return (
    <VictoryLabel
      {...rest}
      index={index}
      backgroundStyle={[{ fill: getIconColor(index), opacity: 1 }]}
      backgroundComponent={
        icons.map((icon, i) => ({
          ...icon,
          props: { color: getIconColor(i), width: isXL ? 15 : 22 },
        }))?.[index]
      }
    />
  );
};

IconLabel.defaultProps = {
  index: 0,
  icons: [],
};

IconLabel.propTypes = {
  index: PropTypes.number,
  icons: PropTypes.array,
};

export default IconLabel;
